<template>
  <div id="app" class="w-full flex justify-center h-full items-center flex-col">
    <div id="nav">
      <router-link to="/">/home </router-link>
      <router-link to="/contact">/contact</router-link>
    </div>
    <router-view/>
    <Footer/>
  </div>
</template>

<style>

#app {

}
</style>
<script>
  import Footer from "./components/Footer";
  export default {
    components: {Footer}
  }
</script>
